import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["icon", "children", "classNames"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const UtilityBoxItem = _ref => {
  let {
    icon,
    children,
    classNames: customClassNames = {}
  } = _ref,
      iconOptions = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    className: classNames(style.UtilityBoxItem, customClassNames.item),
    "data-id": "utility-box-item_index_UtilityBoxItem_div",
    children: [icon && /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
      className: classNames(style.icon, customClassNames.icon),
      type: icon
    }, iconOptions), {}, {
      "data-id": "utility-box-item_index_UtilityBoxItem_Icon"
    })), /*#__PURE__*/_jsx("div", {
      className: classNames(style.childWrapper, customClassNames.childWrapper),
      "data-id": "utility-box-item_index_UtilityBoxItem_div_div",
      children: children
    })]
  });
};

export default UtilityBoxItem;